import ApiService from '../../../../../services/ApiService.js'
import GeneralService from '../../../../../services/GeneralService.js'
import utils from '../../../../../Utils/FormatDate.js'
import ManageSupplier from '../../../Suppliers/components/ManageSupplier.vue'
import AlienatedEquipment from '../AlienatedEquipment.vue'
import ManageAlert from '../../../Alert/components/manageAlert/ManageAlert.vue'
import AddScheduleEquipment from '../addScheduleEquipment/addScheduleEquipment.vue'
import InstitutionInactive from '../../../Institutions/components/institutionInactive/institutionInactive.vue'
import DepartmentInactive from '../../../Department/deparmentInactive/departmentInactive.vue'
import SelectChildEquipments from '../selectChildEquipments.vue'
import EquipmentHistory from './EquipmentHistory.vue'
import NumberAnvisaField from '../../../../../components/NumberAnvisaField.vue'
// import IFCViewer from '../../../../../components/IFCViewer.vue'

export default {
  props: {
    equipmentId: String,
  },

  components: {
    // IFCViewer,
    SelectChildEquipments,
    ManageSupplier,
    AlienatedEquipment,
    ManageAlert,
    AddScheduleEquipment,
    InstitutionInactive,
    DepartmentInactive,
    EquipmentHistory,
    NumberAnvisaField,
  },

  async created() {
    this.userType = JSON.parse(localStorage.getItem('institution')).userType
    const institution = JSON.parse(localStorage.getItem('institution'))
    this.institutionId = institution.id
    this.workshopType = institution.workshopType
    this.institutionInactive = institution.status == 1
    window.scrollTo(0, 0)

    if (this.userType > 1) {
      await this.getUserUnidades()
    } else {
      await this.getUnidades()
    }

    await Promise.all([
      this.getManufacturers(),
      this.getStandardEquipment(),
      this.getCostCenters(),
      this.getContracts(),
      this.getSuppliers(),
    ])

    if (this.equipmentId) {
      this.getEquipment()
    }

    this.currentEquipment.conservationState = this.currentEquipment
      .conservationState
      ? this.currentEquipment.conservationState
      : 0
    this.currentEquipment.technologyFactor = this.currentEquipment
      .technologyFactor
      ? this.currentEquipment.technologyFactor
      : 0

    this.currentEquipment.marketValue = this.currentEquipment.marketValue
      ? this.currentEquipment.marketValue
      : this.currentEquipment.purchasePrice
  },

  data: () => ({
    // ifcModal: false,
    reasonModal: '',
    firstDeparmentId: '',
    childHeaders: [
      {
        text: '',
        align: 'center',
        value: '',
        sortable: false,
      },
      {
        text: 'Identificação',
        align: 'center',
        value: 'identification',
        sortable: false,
      },
      {
        text: 'Equipamento',
        align: 'center',
        value: 'name',
        sortable: false,
      },
      {
        text: 'Número de série',
        align: 'center',
        value: 'serialNumber',
        sortable: false,
      },
      {
        text: 'Fabricante',
        align: 'center',
        value: 'manufacturer',
        sortable: false,
      },
      {
        text: 'Modelo',
        align: 'center',
        value: 'model',
        sortable: false,
      },
      {
        text: 'Ações',
        align: 'center',
        value: 'actions',
        sortable: false,
      },
    ],
    childMobileHeaders: [
      {
        text: '',
        align: 'center',
        value: '',
        sortable: false,
      },
      {
        text: 'Identificação',
        align: 'center',
        value: 'identification',
        sortable: false,
      },

      {
        text: 'Ações',
        align: 'center',
        value: 'actions',
        sortable: false,
      },
    ],
    costTypeLabels: {
      0: 'Custo de Material',
      1: 'Custo de Serviço',
    },
    headersCosts: [
      { text: '', value: '' },
      { text: 'Tipo de Custo', value: 'costType',align: 'center' },
      { text: 'Nº O.S.', value: 'number', align: 'center' },
      { text: 'Custo', value: 'costValue', align: 'center' },
      { text: 'Fornecedor', value: 'supplier', align: 'center' },
      { text: 'Descrição', value: 'description',align: 'center' },
      { text: 'Data', value: 'costDate', align: 'center' },
    ],
    headersCostsMobile: [
      { text: 'Tipo de Custo', value: 'costType',align: 'center' },
      { text: 'Nº O.S.', value: 'number', align: 'center' },
      { text: 'Custo', value: 'costValue', align: 'center' },
      { text: 'Fornecedor', value: 'supplier', align: 'center' },
      { text: 'Data', value: 'costDate', align: 'center' },
    ],
    costsPage: 1,
    costsPageSize: 5,
    costsTotalPages: 1,
    costsTotalItems: 0,
    sizes: [5, 10, 20, 50],
    childModal: false,
    childModalKey: false,
    candlePowerUnits: ['W', 'VA', 'KVA', 'BTU', 'CV'],
    equipmentsCosts: [],
    costsLoading: false,
    errorMessage: '',
    equipmentHistoryDialog: false,
    criticality: '',
    criticalityValue: 0,
    menuPurchaseDate: false,
    menuDeliveryDate: false,
    menuWarrantyStartDate: false,
    menuInstallationEndDate: false,
    loading: false,
    unidadeLoading: false,
    standardEquipmentLoading: false,
    departmentLoading: false,
    costCenterLoading: false,
    contractLoading: false,
    supplierLoading: false,
    historicalLoading: false,
    deleteServiceOrderLoading: false,
    showHistorical: false,
    showSchedule: false,
    firstValid: true,
    alterDialog: false,
    alienatedDialog: false,
    supplierDialog: false,
    alertDialog: false,
    deleteServiceOrderDialog: false,
    scheduleDialog: false,
    dialogKey: false,
    changedData: false,
    isEditing: false,
    error: false,
    institutionInactive: false,
    departmentInactive: false,
    tab: 1,
    purchaseDate: null,
    deliveryDate: null,
    warrantyStartDate: null,
    warrantyEndDate: null,
    installationEndDate: null,
    institutionId: null,
    functionEquipment: null,
    equipmentRisk: null,
    selectedDepartment: {},
    unidadeId: 0,
    unidades: [],
    standardEquipmentId: 0,
    standardEquipments: [],
    currentStandardEquipment: {},
    alert: {},
    departmentId: 0,
    departments: [],
    costCenterId: null,
    costCenters: [],
    contractId: null,
    contracts: [],
    contractValue: 0,
    supplierId: null,
    suppliers: [],
    historicalDepartment: [],
    expanded: [],
    expandedService: [],
    currentServiceOrder: {},
    equipmentSelected: [],
    serviceOrders: [],
    userType: null,
    mtbf: 0,
    workshopType: null,
    currentDepartment: {},
    situations: [
      'Aluguel',
      'Comodato',
      'De médico/Equipe',
      'Empréstimo',
      'Próprio',
      'Terceiros',
      'Convênio',
      'Doação',
    ],
    voltages: [
      '110V',
      '220V',
      '110V / 220V - Bivolt',
      '220V Trifásico',
      '380V Trifásico',
      '440V',
      '480V',
      '13,8KV',
    ],
    degreeImportances: ['A', 'B', 'C'],
    conservationStates: [
      { text: 'Bom', value: 0 },
      { text: 'Ruim', value: 1 },
      { text: 'Péssimo', value: 2 },
    ],
    endLifeFactors: [
      { text: 'Atual', value: null },
      { text: 'End of Life', value: 0 },
      { text: 'End of Service', value: 1 },
    ],
    technologyFactors: [
      { text: 'Atual', value: 0 },
      { text: 'Defasagem Mínima', value: 1 },
      { text: 'Defasado', value: 2 },
    ],
    functionsEquipment: [
      'Acessório',
      'Análise',
      'Diagnóstico',
      'Outros equipamentos de apoio',
      'Suporte à vida',
      'Terapia',
      'Simulador/Analisador/Padrão',
    ],
    equipmentRisks: [
      'Acessório',
      'Injuria',
      'Morte',
      'Sem risco',
      'Terapia ou diagnóstico inapropriado',
    ],
    serviceOrderTypes: [
      'Treinamento',
      'Segurança elétrica',
      'Preventiva',
      'Instalação',
      'Rotina de Inspeção',
      'Corretiva',
      'Calibração',
      'Validação/Qualificação',
    ],
    currentEquipment: {
      id: 0,
      name: '',
      propertyCode: '',
      manufacturer: '',
      location: '',
      model: '',
      serialNumber: '',
      voltage: null,
      candlePower: '',
      candlePowerUnit: 'W',
      identification: '',
      numberAnvisa: '',
      purchaseDate: null,
      endLifeFactor: null,
      situation: null,
      degreeImportance: null,
      exchangeDay: '',
      warrantyTime: '',
      deliveryDate: null,
      warrantyStartDate: null,
      warrantyEndDate: null,
      installationEndDate: null,
      manuals: '',
      accessories: '',
      observation: '',
      alienated: false,
      criticality: 0,
      lifeExpectancy: 0,
      invoice: '',
    },
    unidadeRules: [(v) => !!v || 'Unidade requerida'],
    standardEquipmentRules: [(v) => !!v || 'Equipamento padrão requerido'],
    departmentRules: [(v) => !!v || 'Setor requerido'],
    costCenterRules: [(v) => !!v || 'Centro de custo requerido'],
    nameRules: [
      (v) => !!v || 'Equipamento requerido',
      (v) =>
        (v && v.length <= 128) ||
        'Equipamento deve ter no máximo 128 caracteres',
    ],
    manufacturerRules: [
      (v) => !!v || $t('Fabricante requerido'),
      (v) =>
        (v && v.length <= 128) ||
        'Fabricante deve ter no máximo 128 caracteres',
    ],
    modelRules: [
      (v) => !!v || 'Modelo requerido',
      (v) => (v && v.length <= 64) || 'Modelo deve ter no máximo 64 caracteres',
    ],
    serialNumberRules: [
      (v) => !!v || 'Nº de série requerido',
      (v) =>
        (v && v.length <= 25) || 'Nº de série deve ter no máximo 25 caracteres',
    ],
    situationRules: [(v) => !!v || 'Situação requerida'],
    propertyCodeRules: [
      (v) =>
        !v ||
        v.length <= 20 ||
        'Cód. patrimônio deve ter no máximo 20 caracteres',
    ],
    locationRules: [
      (v) =>
        !v || v.length <= 64 || 'Localização deve ter no máximo 64 caracteres',
    ],
    candlePowerRules: [
      (v) =>
        !v || v.length <= 10 || 'Potência deve ter no máximo 10 caracteres',
    ],
    invoiceRules: [
      (v) =>
        !v || v.length <= 10 || 'Nota fiscal deve ter no máximo 10 caracteres',
    ],
    headers: [
      {
        text: '',
        align: 'center',
        value: '',
        sortable: false,
      },
      {
        text: 'Unidade/Setor Origem',
        align: 'center',
        value: 'source',
        sortable: false,
      },
      {
        text: 'Unidade/Setor Destino',
        align: 'center',
        value: 'destiny',
        sortable: false,
      },
      {
        text: 'Data Migração',
        align: 'center',
        value: 'migretionDate',
        sortable: false,
      },
    ],
    headersMobile: [
      {
        text: 'Data Migração',
        align: 'center',
        value: 'migretionDate',
        sortable: false,
      },
    ],
    headersServiceOrder: [
      {
        text: '',
        align: 'center',
        value: '',
        sortable: false,
      },
      {
        text: 'Nº O.S.',
        align: 'center',

        value: 'number',
      },
      {
        text: 'Nome',
        align: 'center',

        value: 'name',
      },
      {
        text: 'Tipo',
        align: 'center',

        value: 'type',
      },
      {
        text: 'Data Agendamento',
        align: 'center',

        value: 'requestDate',
      },
      {
        text: 'Data Fechamento',
        align: 'center',

        value: 'closeDate',
      },
      {
        text: 'Ações',
        align: 'center',

        value: 'actions',
        sortable: false,
      },
    ],
    headersServiceOrderMobile: [
      {
        text: '',
        align: 'center',
        value: '',
        sortable: false,
      },
      {
        text: 'Nº O.S.',
        align: 'center',

        value: 'number',
        sortable: false,
      },
      {
        text: 'Nome',
        align: 'center',

        value: 'name',
        sortable: false,
      },
      {
        text: 'Ações',
        align: 'center',

        value: 'actions',
        sortable: false,
      },
    ],
    apiService: new ApiService(),
    generalService: new GeneralService(),
    manufacturers: [],
    manufLoading: false,
    ifcLoading: false,
    removeIfcLoading: false,
    uploadProgress: 0,
  }),

  computed: {
    subDepartments() {
      const department = this.departments.find((x) => x.id == this.departmentId)
      return department ? department.subDepartments : []
    },
    buttonText() {
      return this.isEditing ? 'Atualizar' : 'Adicionar'
    },
  },

  methods: {
    async saveIFC() {
      this.ifcLoading = true
      this.uploadProgress = 0

      let formData = new FormData()

      formData.append('file', this.currentEquipment.ifcFilePath)
      formData.append('equipmentId', this.currentEquipment.id)

      const interval = setInterval(() => {
        if (this.uploadProgress < 90) {
          this.uploadProgress += 10
        } else {
          clearInterval(interval)
        }
      }, 500)

      const response = await fetch(
        process.env.VUE_APP_BASE_URL + 'equipment/save-ifc',
        {
          method: 'POST',
          body: formData,
          headers: {
            Authorization: 'Bearer ' + localStorage.getItem('token'),
          },
        }
      )
      clearInterval(interval)
      this.uploadProgress = 100
      this.ifcLoading = false

      if (response.status == 200) {
        window.open(
          process.env.VUE_APP_IFC_BASE_URL + '?id=' + this.currentEquipment.id,
          '_blank',
          'noopener, noreferrer'
        )
      }
    },

    async removeIFC() {
      this.removeIfcLoading = true
      let formData = new FormData()

      formData.append('file', null)
      formData.append('equipmentId', this.currentEquipment.id)
      const response = await fetch(
        process.env.VUE_APP_BASE_URL + 'equipment/save-ifc',
        {
          method: 'POST',
          body: formData,
          headers: {
            Authorization: 'Bearer ' + localStorage.getItem('token'),
          },
        }
      )

      if (response.status == 200) {
        this.currentEquipment.ifcFilePath = null
      }

      this.removeIfcLoading = false
    },

    goToIfc() {
      window.open(
        process.env.VUE_APP_IFC_BASE_URL + '?id=' + this.currentEquipment.id,
        '_blank',
        'noopener, noreferrer'
      )
    },

    setIfc(file) {
      this.currentEquipment.ifcFilePath = file
      this.saveIFC()
    },

    chooseIFC() {
      document.getElementById('ifc-input').click()
    },

    removeChild(itemId) {
      this.currentEquipment.childEquipments =
        this.currentEquipment.childEquipments.filter((x) => x.id != itemId)

      if (this.currentEquipment.id) {
        const model = {
          equipmentId: this.currentEquipment.id,
          childIds: this.currentEquipment.childEquipments.map((x) => x.id),
        }

        this.apiService
          .post(`equipment/updateChilds`, model)
          .then(() => {
            this.$toast.success('Equipamento filho removido com sucesso!')
          })
          .catch(() => {
            this.loading = false
          })
      }
    },

    getManufacturers() {
      this.manufLoading = true
      this.apiService
        .get(`manufacturer/list/${this.institutionId}`)
        .then((response) => {
          this.manufacturers = response.content
          this.manufLoading = false
        })
        .catch(() => {
          this.manufLoading = false
        })
    },

    close() {
      if (this.changedData) {
        this.alterDialog = true
      } else {
        this.$router.push('/equipment')
      }
    },

    closeDialog() {
      if (this.supplierDialog) {
        this.supplierDialog = false
        this.getSuppliers()
      } else if (this.alienatedDialog) {
        this.alienatedDialog = false
        this.close()
      } else if (this.alertDialog) {
        this.alertDialog = false
      } else if (this.scheduleDialog) {
        this.scheduleDialog = false
        this.listServicesOrders()
      } else {
        this.changedData = false
        this.close()
      }
    },

    isNumber(value) {
      return typeof value === 'number'
    },

    addSupplier() {
      this.dialogKey = !this.dialogKey
      this.supplierDialog = true
    },

    openServiceOrder(serviceOrder) {
      const route = this.$router.resolve({
        path: `/editServiceOrder/${serviceOrder.id}`,
      })
      window.open(route.href, '_blank')
    },

    deleteServiceOrder(serviceOrder) {
      this.currentServiceOrder = serviceOrder
      this.deleteServiceOrderDialog = true
      this.dialogKey = !this.dialogKey
    },

    addSchedule() {
      this.equipmentSelected = []
      this.equipmentSelected.push(this.setEquipment())
      this.scheduleDialog = true
      this.dialogKey = !this.dialogKey
    },

    showSuccess(message) {
      this.$emit('show', message)
    },

    createAlert() {
      this.alert = {
        description: `Fim da garantia do Equipamento: ${
          this.currentEquipment.standardEquipment
            ? this.currentEquipment.standardEquipment.name
            : this.currentEquipment.name
        } / ID: ${this.currentEquipment.identification} / Patrimônio: ${
          this.currentEquipment.propertyCode
        } / Fabricante: ${this.currentEquipment.manufacturer}`,
        eventDate: utils.nowDatetimeFormat(
          this.parseDate(this.warrantyEndDate)
        ),
        alertModule: 1,
        equipmentId: this.currentEquipment.id,
      }

      this.dialogKey = !this.dialogKey
      this.alertDialog = true
    },

    alienateEquipment() {
      this.dialogKey = !this.dialogKey
      this.alienatedDialog = true
      this.changedData = false
    },

    selectedStandardEquipment() {
      if (this.standardEquipmentId) {
        this.currentStandardEquipment = this.standardEquipments.find(
          (standardEquip) => standardEquip.id === this.standardEquipmentId
        )

        if (
          this.isNumber(this.currentStandardEquipment.functionEquipment) &&
          this.isNumber(this.currentStandardEquipment.equipmentRisk)
        ) {
          this.functionEquipment =
            this.functionsEquipment[
              this.currentStandardEquipment.functionEquipment
            ]
          this.equipmentRisk =
            this.equipmentRisks[this.currentStandardEquipment.equipmentRisk]
        }

        this.currentEquipment.degreeImportance =
          this.currentStandardEquipment.indexAbc
        this.currentEquipment.lifeExpectancy =
          this.currentStandardEquipment.lifeExpectancy
        this.currentEquipment.name = this.currentStandardEquipment.name

        this.calculateCriticality()
      }
    },

    calculateCriticality() {
      let functionScore = 0
      let riskScore = 0
      let indexAbcScore = 0

      switch (this.functionEquipment) {
        case 'Suporte à vida':
          functionScore = 10
          break
        case 'Terapia':
          functionScore = 8
          break
        case 'Diagnóstico':
          functionScore = 6
          break
        case 'Análise':
          functionScore = 4
          break
        case 'Outros equipamentos de apoio':
          functionScore = 2
          break
        default:
          functionScore = 0
          break
      }

      switch (this.equipmentRisk) {
        case 'Morte':
          riskScore = 7
          break
        case 'Injuria':
          riskScore = 5
          break
        case 'Terapia ou diagnóstico inapropriado':
          riskScore = 3
          break
        case 'Sem risco':
          riskScore = 1
          break
        default:
          riskScore = 0
          break
      }

      switch (this.currentEquipment.degreeImportance) {
        case 'A':
          indexAbcScore = 10
          break
        case 'B':
          indexAbcScore = 5
          break
        default:
          indexAbcScore = 0
          break
      }

      this.criticalityValue = functionScore + riskScore + indexAbcScore

      if (this.criticalityValue >= 19) {
        this.criticality = 'Alta'
      } else if (this.criticalityValue >= 12 && this.criticalityValue < 19) {
        this.criticality = 'Média'
      } else if (this.criticalityValue >= 3 && this.criticalityValue < 12) {
        this.criticality = 'Baixa'
      } else {
        this.criticality = '--'
      }
    },

    selectedCostCenter() {
      const costCenter = this.costCenters.find(
        (x) => x.departmentId === this.departmentId
      )
      if (costCenter && this.costCenterId == null) {
        this.costCenterId = costCenter.id
      }
    },

    async getEquipment() {
      await this.apiService
        .get(`equipment/${this.institutionId}/${this.equipmentId}`)
        .then((response) => {
          this.currentEquipment = response.content
          this.currentEquipment.candlePowerUnit = response.content
            .candlePowerUnit
            ? response.content.candlePowerUnit
            : 'W'

          this.unidadeId = response.content.unidadeId

          this.standardEquipmentId =
            response.content.institutionStandardEquipmentId

          this.currentStandardEquipment = response.content.standardEquipment
          this.departmentId = response.content.departmentId

          if (response.content.costCenterId != null) {
            this.costCenterId = response.content.costCenterId
          } else {
            this.selectedCostCenter()
          }

          this.contractId = response.content.contractId
          this.supplierId = response.content.supplierId
          this.currentEquipment.voltage =
            this.voltages[response.content.voltage]
          this.currentEquipment.situation =
            this.situations[response.content.equipmentAcquisitionSituation]
          this.currentEquipment.contractValue =
            response.content.contractValue == 0
              ? ''
              : response.content.contractValue
          this.contractValue = response.content.contractValue || 0
          this.currentEquipment.exchangeDay =
            response.content.exchangeDay == 0
              ? ''
              : response.content.exchangeDay
          this.currentEquipment.purchasePrice =
            response.content.purchasePrice == 0
              ? ''
              : response.content.purchasePrice

          this.purchaseDate = this.formatInitialDate(
            response.content.purchaseDate
          )
          this.deliveryDate = this.formatInitialDate(
            response.content.deliveryDate
          )

          this.warrantyStartDate = this.formatInitialDate(
            response.content.warrantyStartDate
          )
          this.installationEndDate = this.formatInitialDate(
            response.content.installationEndDate
          )

          this.warrantyEndDate = this.formatInitialDate(
            response.content.warrantyEndDate
          )

          this.functionEquipment =
            this.functionsEquipment[
              response.content.standardEquipment.functionEquipment
            ]

          this.equipmentRisk =
            this.equipmentRisks[
              response.content.standardEquipment.equipmentRisk
            ]

          this.departmentInactive = response.content.department.status == 1
          this.currentEquipment.invoice = response.content.invoice
          this.calculateCriticality()

          this.getMtbf()
          this.getDepartmentHistorical()
          this.listServicesOrders()
          this.listEquipmentCosts()

          this.firstDeparmentId = this.departmentId

          this.isEditing = true
        })
        .catch((err) => {
          this.errorMessage = err.body.message
          this.error = true

          if (err.status === 404) {
            this.$router.push('/equipment')
          }

          setTimeout(() => {
            this.error = false
          }, 4000)
        })
    },

    async getDepartmentHistorical() {
      this.historicalLoading = true
      await this.apiService
        .get(`equipment/institution-migrations/${this.currentEquipment.id}`)
        .then((response) => {
          this.historicalDepartment = response.content.filter(
            (x) => x.lastDepartmentId != x.departmentId
          )
          this.showHistorical = this.historicalDepartment.length > 0
          if (this.showHistorical) this.tab = 2
        })
      this.historicalLoading = false
    },

    async getUnidades() {
      this.unidadeLoading = true

      await this.apiService
        .get(`unidade/list/${this.institutionId}`)
        .then((response) => {
          this.unidades = response.content
        })
        .catch((err) => {
          this.errorMessage = err.body.message
          this.error = true

          setTimeout(() => {
            this.error = false
          }, 4000)
        })

      this.unidadeLoading = false
    },

    async getUserUnidades() {
      this.unidadeLoading = true

      await this.apiService
        .get(`unidade/listByUserAndInstitution/${this.institutionId}`)
        .then((response) => {
          this.unidades = response.content
          this.unidadeLoading = false
        })
    },

    async getStandardEquipment() {
      this.standardEquipmentLoading = true

      this.standardEquipments =
        await this.generalService.getStandardEquipmentsByInstitution(
          this.institutionId
        )

      this.standardEquipmentLoading = false
    },

    async getDepartments() {
      this.departmentLoading = true
      await this.apiService
        .get(`department/list/unidade/${this.unidadeId}`)
        .then((response) => {
          this.departments = response.content
        })
        .catch((err) => {
          this.errorMessage = err.body.message
          this.error = true

          setTimeout(() => {
            this.error = false
          }, 4000)
        })

      this.departmentLoading = false
    },

    async getCostCenters() {
      this.costCenterLoading = true

      if (!this.unidadeId) {
        this.costCenters = []
        this.costCenterLoading = false
        return
      }

      await this.apiService
        .get(`costCenter/listActiveByUnidade/${this.institutionId}/${this.unidadeId}`)
        .then((response) => {
          this.costCenters = response.content
        })
        .catch((err) => {
          this.errorMessage = err.body.message
          this.error = true
          setTimeout(() => {
            this.error = false
          }, 4000)
        })

      this.costCenterLoading = false
    },

    async getContracts() {
      this.contractLoading = true

      await this.apiService
        .get(`contract/list/${this.institutionId}`)
        .then((response) => {
          this.contracts = response.content
          // this.contracts.unshift({
          //   id: 0,
          //   name: "",
          //   number: "",
          // });
        })
        .catch((err) => {
          this.errorMessage = err.body.message
          this.error = true

          setTimeout(() => {
            this.error = false
          }, 4000)
        })

      this.contractLoading = false
    },

    async getSuppliers() {
      ;(this.supplierLoading = true),
        await this.apiService
          .get(`supplier/list/${this.institutionId}`)
          .then((response) => {
            this.suppliers = response.content
            // this.suppliers.unshift({
            //   id: 0,
            //   name: "",
            // });
          })
          .catch((err) => {
            this.errorMessage = err.body.message
            this.error = true

            setTimeout(() => {
              this.error = false
            }, 4000)
          })

      this.supplierLoading = false
    },

    async listServicesOrders() {
      await this.apiService
        .get(`serviceOrder/list/${this.currentEquipment.id}`)
        .then((response) => {
          this.serviceOrders = response.content
          this.showSchedule = response.content.length > 0
        })
    },

    async remove() {
      this.deleteServiceOrderLoading = true

      const user = JSON.parse(localStorage.getItem('user'))
      const model = {
        serviceOrderId: this.currentServiceOrder.id,
        archivedByuserId: user.id,
      }

      await this.apiService
        .delete(`serviceOrder/delete`, model)
        .then(() => {
          this.deleteServiceOrderDialog = false
          this.listServicesOrders()
        })
        .catch((err) => {
          this.errorMessage = err.body.message
          this.error = true

          setTimeout(() => {
            this.error = false
          }, 4000)
        })

      this.deleteServiceOrderLoading = false
      this.deleteServiceOrderDialog = false
    },

    async getMtbf() {
      await this.apiService
        .get(`equipment/mtbf/${this.currentEquipment.id}`)
        .then((response) => {
          this.mtbf = response.content
        })
    },

    async submit() {
      if (this.$refs.firstForm.validate()) {
        if (
          this.firstDeparmentId != this.departmentId &&
          this.reasonModal == false &&
          this.isEditing
        ) {
          this.reasonModal = true
          return
        }

        if (
          this.firstDeparmentId != this.departmentId &&
          !this.currentEquipment.reason &&
          this.isEditing
        ) {
          this.$toast.error('Adicione o motivo da migração para prosseguir!')
          return
        }

        this.loading = true

        let url = 'equipment/add'

        if (this.isEditing) {
          url = 'equipment/edit'
        }

        await this.apiService
          .post(url, this.setEquipment())
          .then(() => {
            if (!this.isEditing) {
              this.$toast.success('Equipamento cadastrado! Mais um pra conta 🛠️')
            }
            this.closeDialog()
            this.reasonModal = false
            this.loading = false
          })
          .catch(() => {
            this.loading = false
          })

        this.loading = false
        this.changedData = false
      } else {
        this.$refs.firstForm.$el.scrollIntoView({ behavior: 'smooth' })
      }
    },

    async listEquipmentCosts(page = 1) {
      this.costsLoading = true
      await this.apiService
        .get(
          `equipment/listCost/${this.currentEquipment.id}?Page=${page}&PageSize=${this.costsPageSize}`
        )
        .then((response) => {
          const content = response.content
          this.equipmentsCosts = (content.data || []).map((cost) => ({
            ...cost,
            number: cost.serviceOrder?.number,
          }))
          this.costsTotalItems = content.pager.totalItems
          this.costsTotalPages = content.pager.totalPages
          this.costsPage = content.pager.currentPage
        })
        .catch((error) => {
          console.error('Erro ao buscar custos:', error)
        })
      this.costsLoading = false
    },

    formatDate(date) {
      return utils.moment(date)
    },

    formatDateTime(date) {
      return utils.dateTime(date)
    },

    parseDate(date) {
      if (!date) return null

      const [day, month, year] = date.split('/')

      return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`
    },

    formatInputDate(date) {
      if (!date) return null

      const [year, month, day] = date.split('T')[0].split('-')
      return `${day}/${month}/${year}`
    },

    formatInitialDate(dateInitial) {
      if (!dateInitial) return null
      const date = new Date(dateInitial),
        day = date.getDate().toString(),
        dayF = day.length == 1 ? '0' + day : day,
        month = (date.getMonth() + 1).toString(),
        monthF = month.length == 1 ? '0' + month : month,
        yearF = date.getFullYear()
      return `${dayF}-${monthF}-${yearF}`
    },

    save(date) {
      this.purchaseDate = this.formatInputDate(
        this.currentEquipment.purchaseDate
      )
      this.$refs.menuPurchaseDate.save(date)

      this.deliveryDate = this.formatInputDate(
        this.currentEquipment.deliveryDate
      )
      this.$refs.menuDeliveryDate.save(date)

      this.warrantyStartDate = this.formatInputDate(
        this.currentEquipment.warrantyStartDate
      )
      this.$refs.menuWarrantyStartDate.save(date)

      this.installationEndDate = this.formatInputDate(
        this.currentEquipment.installationEndDate
      )
      this.$refs.menuInstallationEndDate.save(date)

      this.calculateWarrantyEndDate()
    },

    calculateWarrantyEndDate() {
      if (
        this.warrantyStartDate != null &&
        this.currentEquipment.warrantyTime != ''
      ) {
        this.warrantyEndDate = utils.moment(
          utils.addMonths(
            this.warrantyStartDate,
            this.currentEquipment.warrantyTime
          )
        )
      } else {
        this.warrantyEndDate = ''
      }
    },

    setEquipment() {
      let manufacturer = ''

      if (
        this.currentEquipment.manufacturer &&
        this.manufacturers.find(
          (x) => x.name == this.currentEquipment.manufacturer
        )
      ) {
        manufacturer = this.currentEquipment.manufacturer
          ? this.manufacturers.find(
              (x) => x.name == this.currentEquipment.manufacturer
            )
          : ''
      } else {
        this.$toast.error('Selecione o fabricante')
        return
      }

      const equipment = {
        Id: this.currentEquipment.id,
        subDepartmentId: this.currentEquipment.subDepartmentId,
        InstitutionId: this.institutionId,
        UnidadeId: this.unidadeId,
        InstitutionStandardEquipmentId: this.standardEquipmentId,
        DepartmentId: this.departmentId,
        CostCenterId: this.costCenterId,
        Name: this.currentEquipment.name,
        PropertyCode: this.currentEquipment.propertyCode,
        Manufacturer: manufacturer.name,
        ManufacturerId: manufacturer.id,
        conservationState: this.currentEquipment.conservationState,
        endLifeFactor: this.currentEquipment.endLifeFactor,
        technologyFactor: this.currentEquipment.technologyFactor,
        marketValue: this.currentEquipment.marketValue,
        Location: this.currentEquipment.location,
        Model: this.currentEquipment.model,
        SerialNumber: this.currentEquipment.serialNumber,
        Voltage: this.voltages.indexOf(this.currentEquipment.voltage),
        CandlePower: this.currentEquipment.candlePower,
        CandlePowerUnit: this.currentEquipment.candlePowerUnit,
        Identification: this.currentEquipment.identification,
        ContractId: this.contractId == 0 ? null : this.contractId,
        ContractValue: this.contractValue != '' ? this.contractValue : 0,
        NumberAnvisa: this.currentEquipment.numberAnvisa,
        SupplierId: this.supplierId < 1 ? null : this.supplierId,
        PurchasePrice: this.currentEquipment.purchasePrice
          ? this.currentEquipment.purchasePrice
          : 0,
        PurchaseDate: this.currentEquipment.purchaseDate,
        EquipmentAcquisitionSituation: this.situations.indexOf(
          this.currentEquipment.situation
        ),
        DegreeImportance: this.currentEquipment.degreeImportance,
        ExchangeDay:
          this.currentEquipment.exchangeDay != ''
            ? this.currentEquipment.exchangeDay
            : 0,
        WarrantyTime: this.currentEquipment.warrantyTime,
        DeliveryDate: this.currentEquipment.deliveryDate,
        WarrantyStartDate: this.currentEquipment.warrantyStartDate,
        WarrantyEndDate: this.parseDate(this.warrantyEndDate),
        InstallationEndDate: this.currentEquipment.installationEndDate,
        Manuals: this.currentEquipment.manuals,
        Accessories: this.currentEquipment.accessories,
        Observation: this.currentEquipment.observation,
        Criticality: this.criticalityValue,
        LifeExpectancy: this.currentEquipment.lifeExpectancy,
        Invoice: this.currentEquipment.invoice,
        Alienated: this.currentEquipment.alienated,
        reason: this.currentEquipment.reason,
        isBackup:
          this.currentEquipment.situation == 'Próprio'
            ? this.currentEquipment.isBackup
            : false,
      }

      return equipment
    },
    changePageSize(size) {
      this.costsPageSize = size
      this.costsPage = 1
      this.listEquipmentCosts(1)
    },

    editServiceOrder(serviceOrderId) {
          if (!serviceOrderId) return
          const route = this.$router.resolve({
            path: `/editServiceOrder/${serviceOrderId}`,
          })
          window.open(route.href, '_blank')
        },
  },

  filters: {
    currency(value) {
      if (typeof value !== 'number') return value
      return value.toLocaleString('pt-BR', {
        style: 'currency',
        currency: 'BRL',
      })
    },
  },

  watch: {
    unidadeId() {
      this.getDepartments()
      this.getCostCenters()
    },

    currentEquipment: {
      deep: true,
      handler() {
        this.changedData = true
      },
    },
  },
}
